import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Col } from "react-awesome-styled-grid";
import { FlexContainer, H1Text, Hr, Text } from "../../design";
import React, { useState } from "react";
import FundingSource from "../../assets/imgs/fundingsource.svg";

type Props = {
  tabs: Array,
  tabPanels: Array,
  onSelect: Function,
  defaultSelectedTab: number,
  name: string,
  paymentTypes: string,
  accntName: string,
  tabName: string,
};

const FundingsourceLinkTabs = (props: Props) => {
  const { tabPanels, onSelect, defaultSelectedTab, name, paymentTypes, accntName } = props;
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedTab || 0);

  const localOnSelect = data => {
    setSelectedIndex(data);
    localStorage.setItem(`${name}-tap-index`, data);
    if (onSelect) { onSelect(data); }
  };

  return (
    <FlexContainer
      className="pt-3 pt-lg-5 w-100"
      box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
      display="flow-root"
    >
      <H1Text
        className="px-1 px-md-4"
        marginBottom="30px"
      >
        PROVIDE BANK ACCOUNT
      </H1Text>
      <Tabs className="tab" onSelect={localOnSelect} selectedIndex={selectedIndex} selectedTabClassName="text-primary tab-active">
        <TabList className="px-1 px-md-4 row">
          <Tab className="col-6 col-sm-3 col-md-4 text-center" style={{ outline: "none", cursor: "pointer" }}>
              <Col className="tab-menu-content">
                <div style={{ height: "30px", cursor: "pointer !important" }}>
                  <img src={FundingSource} />
                </div>
                <Text className="tab-menu-content-text text-center" color="inherit" fontWeight="600" style={{ outline: "none", cursor: "pointer" }} paddingBottom="3px">TRANSFER</Text>
              </Col>
            </Tab>
        </TabList>
        {(paymentTypes === 'US') ? (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in United States or Canada to receive funds from {accntName}</Text>
        ) : (
          <Text className="px-1 px-md-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in India to receive funds from {accntName}</Text>
        )}
        <Hr width="100%" marginTop="15px" borderTop="1px solid rgba(0, 0, 0, 0.1)" />
        {tabPanels && tabPanels.map((value, index) => (
          <TabPanel key={index}>
            <div className="mt-4">
              {value.children}
            </div>
          </TabPanel>
        ))}
      </Tabs>
    </FlexContainer>
  )
};

export default FundingsourceLinkTabs;
